// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__eAFQG","container":"contact_container__FeXgg","contactForm":"contact_contactForm__wqW3Y","socials":"contact_socials__MSAHy"};